// extracted by mini-css-extract-plugin
module.exports = {"flexWrap":"_3dyXIWAbY4ceHEMngCG6qU","product":"_2GmOib-tlQpBP_-l91p-am"};